export function getRegion(state) {
  const NE_STATES = [
    'VA', 'WV', 'MD', 'DE', 'PA', 'NJ', 'NY', 'CT', 'RI', 'MA', 'VT', 'NH', 'ME'
  ];
  
  const SE_STATES = [
    'NC', 'SC', 'GA', 'FL', 'AL', 'MS', 'TN', 'KY', 'AR', 'LA'
  ];

  if (NE_STATES.includes(state)) {
    return 'NE';
  } else if (SE_STATES.includes(state)) {
    return 'SE';
  } else {
    return 'Unknown'; // fallback for non-contiguous states, territories, etc.
  }
}

export function calculateDiscountedTotal(state, grandTotal, earlyOrder, prePay, estimatedFreight = 0) {
  // Determine region
  const NE_STATES = [
    'VA', 'WV', 'MD', 'DE', 'PA', 'NJ', 'NY', 'CT', 'RI', 'MA', 'VT', 'NH', 'ME'
  ];
  const SE_STATES = [
    'NC', 'SC', 'GA', 'FL', 'AL', 'MS', 'TN', 'KY', 'AR', 'LA'
  ];

  let region;
  if (NE_STATES.includes(state)) region = 'NE';
  else if (SE_STATES.includes(state)) region = 'SE';
  else region = 'Unknown';

  let discountedTotal = grandTotal;

  if (region === 'NE') {
    // Fixed NE discounts
    if (earlyOrder) discountedTotal *= 1 - 0.05;
    if (prePay) discountedTotal *= 1 - 0.03;
  }
  else if (region === 'SE') {
    // Tiered SE discounts (different for earlyOrder and prePay)
    let earlyOrderDiscount = 0;
    let prePayDiscount = 0;

    if (grandTotal >= 15000 && grandTotal <= 24999) {
      earlyOrderDiscount = 0.02;
      prePayDiscount = 0.04;
    } else if (grandTotal >= 25000 && grandTotal <= 34999) {
      earlyOrderDiscount = 0.03;
      prePayDiscount = 0.06;
    } else if (grandTotal >= 35000 && grandTotal <= 125000) {
      earlyOrderDiscount = 0.05;
      prePayDiscount = 0.08;
    }

    // Apply sequential stacking
    if (earlyOrder) discountedTotal *= 1 - earlyOrderDiscount;
    if (prePay) discountedTotal *= 1 - prePayDiscount;
  }

  return Number(discountedTotal + (estimatedFreight || 0)).toFixed(2);
}


export function getDiscountPercent(state, discountType, grandTotal = 0) {
  const NE_STATES = [
    'VA', 'WV', 'MD', 'DE', 'PA', 'NJ', 'NY', 'CT', 'RI', 'MA', 'VT', 'NH', 'ME'
  ];
  const SE_STATES = [
    'NC', 'SC', 'GA', 'FL', 'AL', 'MS', 'TN', 'KY', 'AR', 'LA'
  ];

  let region;
  if (NE_STATES.includes(state)) region = 'NE';
  else if (SE_STATES.includes(state)) region = 'SE';
  else region = 'Unknown';

  if (region === 'NE') {
    // Fixed NE discount
    if (discountType === 'earlyOrder') return 5;
    if (discountType === 'prePay') return 3;
  }

  if (region === 'SE') {
    // Tiered SE discounts
    let earlyOrderDiscount = 0;
    let prePayDiscount = 0;

    if (grandTotal >= 15000 && grandTotal <= 24999) {
      earlyOrderDiscount = 2;
      prePayDiscount = 4;
    } else if (grandTotal >= 25000 && grandTotal <= 34999) {
      earlyOrderDiscount = 3;
      prePayDiscount = 6;
    } else if (grandTotal >= 35000 && grandTotal <= 125000) {
      earlyOrderDiscount = 5;
      prePayDiscount = 8;
    }

    if (discountType === 'earlyOrder') return earlyOrderDiscount;
    if (discountType === 'prePay') return prePayDiscount;
  }

  // Default no discount
  return 0;
}


export const parsedDiscount = (value = "") => {
    const hasB = String(value).startsWith("B");

    const discount = parseInt(
        String(value).replace(/[^0-9]/g, ""),
        10
    );

    return {
        discount: isNaN(discount) ? 0 : discount,
        isBulk: hasB
    };
};
